import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=69003fd5&scoped=true"
import script from "./ProfilePage.vue?vue&type=script&lang=ts"
export * from "./ProfilePage.vue?vue&type=script&lang=ts"
import style0 from "./ProfilePage.vue?vue&type=style&index=0&id=69003fd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69003fd5",
  null
  
)

export default component.exports